import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateToStringPipe'
})
export class DateToStringPipe implements PipeTransform {
  constructor() {
  }

  transform(date: Date, skipYear: boolean = false) {
    if (skipYear) {
      return Intl.DateTimeFormat(undefined, {day: '2-digit', month: 'short'}).format(date);
    }

    return Intl.DateTimeFormat(undefined, {year: 'numeric', day: '2-digit', month: 'short'}).format(date);

  }
}
